import moment from "moment";
import { useTranslation } from "react-i18next";
import { IoIosEye, IoIosEyeOff } from "react-icons/io";
import { amountFormat } from "../services/common.service";
import { Button, Divider, Empty, Tooltip } from "antd";

export default function DetailedStatementList({
  dataSource,
  reqValues,
  fetchMoreStatements,
  setShowModal,
  statementExcelDownload,
  emailStatementform,
  noRecords,
}) {
  const { t } = useTranslation();
  return (
    <>
      <div className="mb-2">
        {dataSource.length > 0 && (
          <>
            <Tooltip
              placement="top"
              title={""}
              overlayInnerStyle={{ textAlign: "center" }}
            >
              <Button
                size="small"
                type="link"
                onClick={() => {
                  setShowModal(true);
                  emailStatementform.setFieldsValue({
                    maskAccountNo: true,
                    allemailpdf: "sendEmail",
                  });
                }}
              >
                {t("buttons.download_pdf_btn", {
                  defaultValue: "Download As PDF",
                })}
              </Button>
            </Tooltip>

            <Divider type="vertical" />
            <Tooltip
              placement="top"
              title={""}
              overlayInnerStyle={{ textAlign: "center" }}
            >
              <Button
                size="small"
                type="link"
                onClick={() => statementExcelDownload()}
              >
                {t("buttons.download_excel_btn", {
                  defaultValue: "Download As Excel",
                })}
              </Button>
            </Tooltip>
          </>
        )}
      </div>
      {dataSource?.length > 0 ? (
        <>
      {dataSource.map((option, idx) => (
        <div key={idx}>
          <div className="account-row-data mb-2">
            <div className="list-row-display-item ">
              <div>
                <div className="mx-2 ministetement-ref">
                  {option.refNo || "-"}
                </div>
                <div className="mx-2 ministatement-desc">
                  {option?.txnTypeDesc || option?.narration}
                </div>
              </div>

              <div align="right">
                <div className="debit account-balance">
                  {(option.debitOrCredit === "Debit" ||
                    option.debitOrCredit === "D") &&
                    amountFormat(option.amount || "0", option.txnCcy)}
                </div>
                <div className="credit account-balance">
                  {(option.debitOrCredit === "Credit" ||
                    option.debitOrCredit === "C") &&
                    amountFormat(option.amount || "0", option.txnCcy)}
                </div>
                <div className="list-item-heading">
                  {moment(option.txnDate).format("DD-MM-YYYY")}
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
      </>
      ) : !noRecords && (
        <Empty
          description=""
        />
      )}
      {noRecords && (
        <Empty
          description={t("pages.my_accounts.casa.no_statements_found", {
            defaultValue: "No Statements Found",
          })}
        />
      )}
      {reqValues.hasMoreData === "Y" && (
        <div align="center">
          <Button type="default" onClick={() => fetchMoreStatements()}>
            {t("buttons.load_more_stmt_btn", {
              defaultValue: "Load More Statements",
            })}
          </Button>
        </div>
      )}
    </>
  );
}
